<template>
  <hel-module title="用能构成" :class="scope.clsPrefix" v-loading="loading">
    <!-- <template slot="extra">
      <span :class="['trend-badge', growthRate >= 0 ? 'trend-up' : 'trend-down']">
        {{ growthRate >= 0 ? '+' : '' }}{{ growthRate.toFixed(1) }}%
      </span>
    </template> -->
    <div class="cost-container">

      <div class="cost-content">
        <div class="chart-center-text">
        <div class="center-label">折标煤</div>
        <div class="center-value">{{ totalAmount }}</div>
        <div class="center-unit">{{ totalUnit }}</div>
      </div>
        <div id="analysis_costChart" class="cost-chart">
      </div>
      <div class="cost-list">
        <div class="list-item" v-for="(item, index) in costItems" :key="index">
          <div class="item-header">
            <span class="item-dot" :style="{ background: item.color }"></span>
            <span class="item-name">{{ item.name }}</span>
          </div>
          <div class="item-value">
            {{ item.stdCoalText }}<span class="value-ratio">（{{ item.ratioText }}）</span>
          </div>
        </div>
      </div>
      </div>

    </div>
  </hel-module>
</template>

<script>
import HelModule from './common/module/index.vue'
import * as echarts from 'echarts'
import axios from 'axios'
import { getToken } from '@/utils/auth'
export default {
  name: 'CostAnalysis',
  components: {
    HelModule
  },
  props: {
    data: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      loading: false,
      scope: {
        clsPrefix: 'rvc-cosmoplat-workspace-cost-analysis'
      },
      // 用能结构（折标煤），由 /kx/ceo/data 接口 energyStructureList 填充
      costItems: [],
      totalAmount: '--',
      totalUnit: 'tce',
      // 用能结构配色（5 项）
      structureColors: ['#4a5ff3', '#7D8EF5', '#ABB6F9', '#DADFFC', '#5AD8A6']
    }
  },
  computed: {},
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.fetchCostAnalysis()
    })
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    // 数值加千分位（至多保留两位小数）
    formatNumber(value) {
      const num = Number(value)
      if (value === null || value === undefined || value === '' || Number.isNaN(num)) {
        return value
      }
      return num.toLocaleString('zh-CN', { maximumFractionDigits: 2 })
    },
    async fetchCostAnalysis() {
      this.loading = true
      try {
        const response = await axios.get(
          '/energy-api/kx/ceo/data',
          {
            headers: {
              token: getToken()
            }
          }
        )
        const res = response.data || {}
        const data = res.data || {}
        const list = data.energyStructureList || []

        this.totalAmount = this.formatNumber(data.totalEnergyStdCoal) || '--'

        this.costItems = list.map((item, index) => ({
          name: item.name,
          // 列表展示折标煤值（占比）
          stdCoalText: this.formatNumber(item.stdCoalValue),
          ratioText: (Number(item.ratio) || 0).toFixed(1) + '%',
          color: this.structureColors[index % this.structureColors.length],
          // 环图取折标煤值
          amount: Number(item.stdCoalValue) || 0
        }))

        this.$nextTick(() => {
          this.drawChart()
        })
      } catch (error) {
        console.error('获取用能构成数据失败:', error)
      } finally {
        this.loading = false
      }
    },
    drawChart() {
      const chart = echarts.init(document.getElementById('analysis_costChart'))
      const option = {
        color: this.structureColors,
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c} ({d}%)'
        },
        series: [
          {
            type: 'pie',
            radius: ['70%', '100%'],
            center: ['50%', '50%'],
            avoidLabelOverlap: false,
            hoverAnimation: false,
            itemStyle: {
              // borderRadius: 4
            },
            label: {
              show: false,
              position: 'center'
            },
            labelLine: {
              show: false
            },
            data: this.costItems.map((item) => ({
              value: item.amount,
              name: item.name,
              itemStyle: {
                color: item.color
              }
            }))
          }
        ]
      }
      chart.setOption(option)
      this.chartInstance = chart
    },
    handleResize() {
      if (this.chartInstance) {
        this.chartInstance.resize()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$class-prefix: "rvc-cosmoplat-workspace-cost-analysis";
.#{$class-prefix} {
  .trend-badge {
    font-size: 12px;
    font-weight: 500;
    padding: 2px 8px;
    height: 16px;
    border-radius: 8px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 12px;
    line-height: 12px;
    &.trend-up {
      background: #F6FFED;
      color: #73B950;
    }
    &.trend-down {
      background: #FEEDED;
      color: #F44F4F;
    }
  }
  .cost-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    padding: 10px 0;
  }
  .chart-center-text {
      position: absolute;
      top: 50%;
      left: calc(50% - 110px);
      transform: translate(-50%, -50%);
      text-align: center;
      z-index: 1000;
      .center-label {
      font-family: PingFangSC-Medium;
      font-weight: 600;
      font-size: 12px;
      color: #333333;
    }
    .center-value {
      font-size: 24px;
      font-weight: 700;
      color: #333;
      // line-height: 36px;
    }
    .center-unit {
      font-size: 12px;
      color: #333;
      font-family: PingFangSC-Medium;
    }
    }
  .cost-chart {
    position: relative;
    width: 130px;
    height: 130px;
    flex-shrink: 0;
    margin-right: 32px;

  }
  .cost-list {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 14px;
  }
  .list-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .item-header {
    // width: 100px;
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .item-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
  }
  .item-name {
    font-size: 13px;
    color: #666666;
    font-weight: 400;
  }
  .item-value {
    font-size: 13px;
    color: #333333;
    font-weight: 600;
    text-align: left;
    .value-ratio {
      font-size: 12px;
      font-weight: 400;
      color: #999999;
    }
  }
}
.cost-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 350px;
  padding: 0px;
  // gap: 32px;
}
</style>
